/* eslint-disable react/jsx-key */
import React, { useRef } from 'react'
import { PreviewBody, PreviewFooter, PreviewLayout } from '../sub-components/PreviewLayout'
import LoadingDiscountStrip from '../skeletons/LoadingDiscountStrip'
import { ElementsPageType } from 'src/lib/types/uiPreview'
import PreviewOrderSummary from '../sub-components/PreviewOrderSummary'
import LoadingPhoneInput from '../skeletons/LoadingPhoneInput'
import PreviewCTA from '../sub-components/PreviewCTA'
import PreviewBadges from '../sub-components/PreviewBadges'
import PreviewDeliveryInformation from '../sub-components/PreviewDeliveryInformation'
import ExitCouponSheet from '../sub-components/ExitCouponSheet'
import DelhiveryConfirmationSheet from '../sub-components/DelhiveryConfirmationSheet'
import { useLocale } from 'src/lib/hooks/useLocal'
import { useExitNudge } from 'src/lib/contexts/ExitNudgeContext'
import { useDelhiveryPreview } from 'src/lib/contexts/DelhiveryPreviewContext'
import { useCustomizeUIContext } from 'src/lib/contexts/CustomizeUIProvider'
import { DELHIVERY_CONFIRMATION_DIALOG_KEY } from 'src/assets/CustomizeUIConfig'

const ElementsPage: React.FC<ElementsPageType> = ({
  orderSummaryConfig,
  colorPalette,
  loginButtonCTAText,
  trustBadgesConfig,
  OrderSummaryConfig
}) => {
  const { t } = useLocale()
  const phoneFrameRef = useRef<HTMLDivElement | null>(null)
  const container = phoneFrameRef.current

  const { state: exitNudge, showPreview, discoveredCouponData } = useExitNudge()
  const { showDelhiveryPreview, setShowDelhiveryPreview } = useDelhiveryPreview()
  const delhiveryConfirmation = useCustomizeUIContext(c =>
    c.state.dialogDisplayConfig.find(dialog => dialog.key === DELHIVERY_CONFIRMATION_DIALOG_KEY)
  )
  const { isEnabled, selectedOption, exitCoupon, urgency } = exitNudge

  const previewCouponValue = discoveredCouponData
    ? discoveredCouponData.amount_type === 'PERCENTAGE'
      ? `${discoveredCouponData.concession_amount}%`
      : `₹${discoveredCouponData.concession_amount}`
    : exitCoupon.couponValue || undefined
  return (
    <>
      <PreviewLayout
        showTotal={{ isEnabled: true, showStrikeThrough: orderSummaryConfig?.isPriceStrikeThroughEnabled }}
        orderSummaryConfig={OrderSummaryConfig}
        containerRef={phoneFrameRef}
      >
        <>
          <PreviewBody>
            {!(orderSummaryConfig.isOnePageCheckoutEnable || orderSummaryConfig.showOrderSummaryAs === 'HEADER') && (
              <PreviewOrderSummary orderSummaryConfig={orderSummaryConfig} />
            )}
            {!orderSummaryConfig.isOnePageCheckoutEnable && (
              <LoadingDiscountStrip
                isHidden={false}
                skeleton={{
                  layout: 'row',
                  justify: 'space-between',
                  config: [
                    {
                      layout: 'row',
                      config: [
                        { height: 1, width: 1 },
                        { height: 1, width: 6 }
                      ]
                    },
                    { height: 1, width: 1 }
                  ]
                }}
                isCard={true}
              />
            )}
            {!orderSummaryConfig.isOnePageCheckoutEnable && (
              <LoadingPhoneInput
                borderColor={colorPalette.primaryColor}
                skeleton={{
                  layout: 'row',
                  config: [
                    {
                      height: 1.5,
                      width: 14
                    }
                  ]
                }}
              />
            )}
            <PreviewDeliveryInformation {...orderSummaryConfig} />
            {orderSummaryConfig.isOnePageCheckoutEnable && (
              <>
                <div className='font-semibold text-sm text-coal-dark w-full'>{t('offer_and_rewards_title')}</div>
                <LoadingDiscountStrip
                  isHidden={false}
                  skeleton={{
                    layout: 'row',
                    justify: 'space-between',
                    config: [
                      {
                        layout: 'row',
                        config: [
                          { height: 1, width: 1 },
                          { height: 1, width: 6 }
                        ]
                      },
                      { height: 1, width: 1 }
                    ]
                  }}
                  isCard={true}
                />
              </>
            )}
          </PreviewBody>
          {!orderSummaryConfig.isOnePageCheckoutEnable && (
            <PreviewFooter>
              <PreviewCTA
                color={colorPalette.primaryColor ?? '#5a31f4'}
                textColor={colorPalette.primaryTextColor ?? '#FFFFFF'}
                CTAText={loginButtonCTAText}
                isSecuredByTextEnabled={true}
                isAnchored={false}
              />
              <PreviewBadges
                badges={trustBadgesConfig?.badges ?? []}
                showBadges={trustBadgesConfig?.showBadges ?? false}
              />
              <div className='w-full h-28' />
            </PreviewFooter>
          )}
        </>
      </PreviewLayout>

      {container && (
        <DelhiveryConfirmationSheet
          open={showDelhiveryPreview}
          onOpenChange={setShowDelhiveryPreview}
          container={container}
          duration={
            delhiveryConfirmation && delhiveryConfirmation.duration > 0 ? delhiveryConfirmation.duration / 1000 : 3
          }
          primaryColor={colorPalette.primaryColor ?? '#18181B'}
          primaryTextColor={colorPalette.primaryTextColor ?? '#FFFFFF'}
        />
      )}

      {container && (
        <ExitCouponSheet
          open={showPreview}
          container={container}
          nudgeType={selectedOption}
          primaryColor={colorPalette.primaryColor ?? '#18181B'}
          primaryTextColor={colorPalette.primaryTextColor ?? '#FFFFFF'}
          badgeText={exitCoupon.badgeLabel || undefined}
          nudgeMessage={exitCoupon.nudgeMessage || undefined}
          badgeColor={exitCoupon.badgeBackground}
          badgeTextColor={exitCoupon.badgeText}
          nudgeTextColor={exitCoupon.nudgeText}
          couponValue={previewCouponValue}
          urgencyTitle={urgency.title || undefined}
          urgencyFomoMessage={urgency.fomoMessage || undefined}
          urgencyTextColor={urgency.textColor}
        />
      )}
    </>
  )
}

export default ElementsPage
